import { LoginPanel } from '../../features/auth/components/LoginPanel'

export function LoginPage() {
  return (
    <div className="login-page">
      <LoginPanel />
    </div>
  )
}
